import * as React from 'react';
import { FC } from 'react';

import { FeatureEmptyState } from 'components/features/components/empty-state';
import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';

import { Container, Loading } from './loyalty-not-enrolled.styled';
import { useFeaturesLoyaltyNotEnrolled } from './use-features-loyalty-not-enrolled';

const LoyaltyNotEnrolled: FC = () => {
  const { data, loading } = useFeaturesLoyaltyNotEnrolled();
  const isDesktop = useMediaQuery(MediaQuery.Desktop);

  if (loading) {
    return <Loading fillColor={Styles.color.primary} />;
  }
  if (!data) {
    return null;
  }
  return (
    <Container>
      <FeatureEmptyState content={data} showCTA={isDesktop} />
    </Container>
  );
};

export default LoyaltyNotEnrolled;
